import { makeApiRequest } from '../../utils/api-utils';

// Privacy Policy DTOs aligned with API documentation
export interface PrivacyPolicyDto {
  id: string;
  version: string;
  privacy_policy_text: string;
  is_expired: boolean;
  is_active: boolean;
  created_at: string; // ISO datetime
  updated_at: string; // ISO datetime
}

export interface CreatePrivacyPolicyDto {
  version: string;
  privacy_policy_text: string;
}

// Generic API response shape from makeApiRequest
export interface ApiResponse<T> {
  data?: T;
  status: number;
  error?: string;
}

// Service functions
export const getAllPrivacyPolicies = async (): Promise<ApiResponse<PrivacyPolicyDto[]>> =>
  makeApiRequest('/privacy-policy/');

export const createPrivacyPolicy = async (
  data: CreatePrivacyPolicyDto,
): Promise<ApiResponse<PrivacyPolicyDto>> =>
  makeApiRequest('/privacy-policy/', {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const getPrivacyPolicyById = async (
  policyId: string,
): Promise<ApiResponse<PrivacyPolicyDto>> =>
  makeApiRequest(`/privacy-policy/${policyId}`);

export const getActivePrivacyPolicy = async (): Promise<ApiResponse<PrivacyPolicyDto>> =>
  makeApiRequest('/privacy-policy/active');

export const expirePrivacyPolicy = async (
  policyId: string,
): Promise<ApiResponse<PrivacyPolicyDto>> =>
  makeApiRequest(`/privacy-policy/${policyId}/expire`, { method: 'PUT' });

export const activatePrivacyPolicy = async (
  policyId: string,
): Promise<ApiResponse<PrivacyPolicyDto>> =>
  makeApiRequest(`/privacy-policy/${policyId}/activate`, { method: 'PUT' });

